import React, { useState, forwardRef, useImperativeHandle, useEffect, useMemo } from "react";
import FlexView from "react-flexview";
import DataGrid from "../../../../../shared/components/Grid";
import {exportGrid, initialColsSelector, onChangeColumns} from "../../../../../shared/components/Grid/functions";
import { resetFilters } from "../../../../../shared/components/Grid/functions/filters";
import { getColumnDefs } from "./columnDefs";

export interface Props {
  data: any;
  ref: any;
  style?: any;
  selector: boolean;
  onSelected(selected: any): any;
  onChange(row: any, refreshAdjuntos: boolean): any;
  selected: any;
  columnsUser:any;
  user:any;
}

export const GridResultsScreen = forwardRef((props:Props, ref:any) => {
  let { data, style, selector, onSelected, onChange, selected,columnsUser,user} = props;

  //let columnDefs = getColumnDefs(columnsUser);
  let [columnDefs, setColumnDefs] = useState<any>([])
  let [columnsState, SetColumnsState] = useState(selector?initialColsSelector(columnDefs):[])
  let [api, setApi] = useState<any>(undefined)

  useEffect(()=>{setColumnDefs(getColumnDefs(columnsUser,user))},[columnsUser,user])

  useEffect(()=>{
      onRowSelection(api)
  },[data])

  const onRowValueChanged = (api: any, event: any) => {
		onChange && onChange(event.data, false);
  };

  const onCellValueChanged = (api: any, event: any) => {
		//onChange && onChange(event.data, false);
  };
  
  const onHideColumn = (newColumns:[any]) =>{
    let newState = onChangeColumns(newColumns, columnDefs);
    SetColumnsState(newState)
  }

  const onRowSelection = (api:any) =>{
    let dataRow = api && api.getSelectedRows();
    if(dataRow && dataRow.length!==selected.length){
      onSelected && onSelected(dataRow);
    }
  }

  const onFilterChanged = (api:any) =>{
    api && api.deselectAll();
    onSelected([])
  }

  const ColumnsExport = useMemo(()=>{
    if(api!==undefined){
      let _cols:string[] = api && api.columnController.allDisplayedColumns.map((c:any)=> c.colId)
      let posCodObra = _cols.findIndex((col)=> col==="codCentroObra");

      if(posCodObra>0)
        _cols.splice(posCodObra+1,0,"obra")

      return _cols;
    }
  },[api])

  useImperativeHandle(
    ref,
    () => ({
        onExport() {
            api && exportGrid({ fileName: "Partes", api: api, columnKeys: ColumnsExport })
        },
        onFilterClear(){
          api && resetFilters(api)
        }
     })
  )

  const updateApi = (api:any) =>{
    setApi(api)
  }

    return (
      <FlexView grow column>
        <DataGrid
        data={data}
        columnDefs={columnDefs}
        columnsState={columnsState}
        selector={selector}
        floatingFilter
        fileExportName="Partes"
        onHideColumn = {onHideColumn}
        onRowSelected={onRowSelection}
        onRowValueChanged={onRowValueChanged}
        onCellValueChanged={onCellValueChanged}
        onFilterChanged={onFilterChanged}
        rowselection="multiple"
        suppressRowClickSelection={true}
        updateApi={updateApi}
        />
      </FlexView>
    );
})